import { useEffect, useState } from 'react'
import MaintenanceData from '../models/MaintenanceData'

export const useMaintenance = () => {
  const [maintenance, setMaintenance] = useState<MaintenanceData>({
    isActive: false,
    isScheduled: false,
    messageCatalan: '',
    messageSpanish: '',
    messageEnglish: '',
  })

  // Check if we need to show maintenance banner or mode every 15 minutes.
  useEffect(() => {
    const checkMaintenance = async () => {
      const response = await fetch('/maintenance.json')
      if (response.ok) {
        const data = await response.json()
        setMaintenance(data)
      }
    }

    checkMaintenance()

    const fifteenMinutes = 15 * 60 * 1000
    const interval = setInterval(() => checkMaintenance(), fifteenMinutes)

    return () => clearInterval(interval)
  }, [])

  return { maintenance }
}
